module.exports = __webpack_public_path__ + "img/container-5.8a59df5a.png";